import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { confirmAlert } from 'react-confirm-alert';

import WebCamFilters from './_fiters';
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import { showLoader } from "../../../components/loader/loader";
import { ButtonTableDelete, ButtonTableEdit } from "../../../components/buttons/buttonsActions";
import { showToastCustom } from "../../../components/toast/customToast";
import { utilHelper } from "../../../jwt/_helpers";
import { webCamService } from "../../../jwt/_services/hotel/webCamService";
import { ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, error, LIST, NO, YES } from "../../../components/i18n/i18n";

const WebCamList = ({ setForm }) => {
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false)

    //Bootstraptable
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [totalSize, setTotalSize] = useState(10);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [dataFilter, setDataFilter] = useState({
        code   : null,
        status : null,
        name   : null,
    });

    //Place items
    const [listItems, setListItems] = useState([]);

    useEffect(() => refreshDataList(page, currentIndex, sizePerPage, dataFilter), []);

    const refreshDataList = (page, currentIndex, sizePerPage, _dataFilters) => {
        setLoading(true);

        webCamService.search(currentIndex, sizePerPage, _dataFilters)
        .then(result => {
            if (result){
                setListItems(result.data);
                setTotalSize(result?.total ?? 0);
                setCurrentIndex(currentIndex);
                setPage(page);
                setSizePerPage(sizePerPage);
            } else {
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
            }
            setLoading(false);
        })
        .catch(errorMessage => {
            setLoading(false);
            setListItems([]);
            setTotalSize(0);
            setCurrentIndex(0);
            setPage(1);
            setSizePerPage(10);
            showToastCustom(error, errorMessage);
        });
    }

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage);
    };

    const confirmDelete = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{ARE_YOU_SHURE_MSG}</p>
            <button onClick={ onClose }>{ NO }</button>
            <button className="btn-alert-delete"
                onClick={() => {
                    deleteItem(data)
                    onClose();
                }}
            >
                { YES }
            </button>
        </div>
    });

    const deleteItem = (data) => {
        setLoading(true);

        webCamService.deleteItem(data.id).then(data => {
            setLoadData(!loadData)
            refreshDataList(page, currentIndex, sizePerPage);

            if (utilHelper.hasAssociateRecords()) 
                utilHelper.restartAssociateRecords();
            
        }).catch(error => {
            setLoading(false);
            console.log("Error al eliminar la ingotmacion ",error);
        })
        ;
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        setForm(true, itemToEdit, "FORM");
    }

    const handleStatusChange = async (id, data, status) => await webCamService.updateItem(id, { ...data, status:status })

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        headerStyle: {width: '200px'}
    }, {
        dataField: 'code',
        text: 'Código',
        sort: true,
    },{
        dataField: 'name',
        text: 'Nombre',
        sort: true,
    }, {
        dataField: 'status',
        text: "Activo",
        sort: true,
        headerStyle: {width: '80px'},
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <GenericSwitch
            id={ row?.id }
            initialState={ row?.status }
            onChange={ handleStatusChange }
        />
    }, {
        dataField: '-',
        text: 'Acción',
        headerStyle: {width: '140px'},
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <>
            <ButtonTableDelete onClick={() => confirmDelete(row)}/>
            <ButtonTableEdit onClick={() => editItem(row)}/>
        </>
    }];

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDataList(page, currentIndex, sizePerPage, _dataFilter);
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{LIST}
            </CardTitle>

            <WebCamFilters refreshFiltered={ refreshFiltered } />

            <CardBody className="">
                { loading && showLoader() }
                <BootstrapTable
                    striped hover
                    tableHeaderClass='mb-0'
                    remote
                    keyField="id"
                    data={ listItems }
                    columns={ columns }
                    noDataIndication="No se encontró información registrada"
                    pagination={ paginationFactory({page, sizePerPage, totalSize}) }
                    onTableChange={ handleTableChange }
                />
            </CardBody>
        </Card>
    )
}

export default WebCamList
